// ============================================================
// schedulePayload — DnD系保存（移動/入替/リサイズ）の共通ペイロード
// ============================================================

import { Reservation } from './types';

/** スケジュールのみ更新の保存ペイロード（detail は構造的に存在しない） */
export type ScheduleOnlyPayload = Pick<
  Reservation,
  'id' | 'vehicle_id' | 'start_date' | 'end_date' | 'status' | 'customer_name'
>;

/**
 * 移動・入替・リサイズの保存用ペイロードを生成する (2026-05-31 / 2026-06-13 / 2026-06-20 修正の集約)。
 *
 * これらは vehicle_id と日時のみ変更する操作。detail を一切含めずに送ることで以下を回避する:
 *   - sparse な detail (memo だけ等) を backend が受け付けず 500 を返す事象
 *     (7d8f505 の partial-safe 化以降に顕在化)
 *   - カレンダーのキャッシュ予約は detail 未ロードのことがあり、その値で
 *     detail を組むと既存の価格等を 0/'' で破壊するリスク (2026-05 の580件事象と同根)
 *   - {...reservation} から .detail を消すだけでは不十分: mapReservation が detail を
 *     root に展開する (base_price/pax/noc 等) ため、それらが buildDetailPayload に
 *     拾われ detail が再生成される。だから「必要フィールドの明示列挙」で漏れを防ぐ
 *
 * ※ この経路では memo 追記は永続化されない (detail.memo が必要になり 500 を誘発するため)。
 *   楽観更新のキャッシュには memo 付きの予約を入れるので、画面上は一時的に表示される。
 *
 * ルール: DnD 系の新しい保存経路を作るときは必ずこの関数を通すこと。
 * regression テスト: __tests__/schedulePayload.test.ts（detail が絶対に含まれないことを固定）
 * 仕様書: md/master_md/ref-save-reservation.md
 */
export function toScheduleOnlyPayload(r: Reservation): ScheduleOnlyPayload {
  return {
    id: r.id,
    vehicle_id: r.vehicle_id,
    start_date: r.start_date,
    end_date: r.end_date,
    status: r.status,
    customer_name: r.customer_name,
  };
}
